import type { Tentativa } from '@/domain/model/Tentativa';
import type { TentativaGateway } from '@/application/port/out/TentativaGateway';
import type { ListTentativasUseCase, GetTentativaUseCase } from '@/application/port/in/TentativaUseCase';

export class ListTentativas implements ListTentativasUseCase {
  constructor(private readonly g: TentativaGateway) {}
  execute(avaliacaoId: string, matriculaId: string): Promise<Tentativa[]> {
    return this.g.list(avaliacaoId, matriculaId);
  }
}
export class GetTentativa implements GetTentativaUseCase {
  constructor(private readonly g: TentativaGateway) {}
  execute(id: string): Promise<Tentativa> { return this.g.get(id); }
}
